/**
 * Status operacional do paciente na lista ecommerce (cache docs + liberações).
 * Chip e filtro compartilham resolvePatientEcommerceOpState.
 * @module patientEcommerceStatus
 */

import type { Patient } from "fhir/r5";

import {
  resolvePatientEcommerceOpState,
  type PatientEcommerceOpState,
} from "./patientEcommerceOpState";
import {
  countTransactionsByOpFilter,
  matchesPatientOpFilter,
  matchesTransactionOpFilter,
  type PatientOpFilter,
} from "./patientListFilters";
import type { DocumentTransactionRow, TransactionOpState } from "./documentTransactions";

export interface PatientEcommerceStatusChip {
  label: string;
  color: "default" | "info" | "success" | "warning" | "error";
}

const CHIP_BY_STATE: Record<
  PatientEcommerceOpState,
  PatientEcommerceStatusChip
> = {
  docs_pending: { label: "Documentos pendentes", color: "warning" },
  docs_to_approve: { label: "Aguardando aprovação", color: "info" },
  docs_rejected: { label: "Documento recusado", color: "error" },
  awaiting_release: { label: "Aguardando liberação", color: "info" },
  docs_released: { label: "Documentos liberados", color: "success" },
  purchase_completed: { label: "Compra concluída", color: "success" },
  no_documents: { label: "Sem documentos", color: "warning" },
  loading: { label: "Carregando…", color: "default" },
  unknown: { label: "Indefinido", color: "default" },
};

export function getPatientEcommerceStatusChip(
  patient: Patient,
): PatientEcommerceStatusChip {
  return CHIP_BY_STATE[resolvePatientEcommerceOpState(patient)];
}

export function getTransactionEcommerceStatusChip(
  state: TransactionOpState,
): PatientEcommerceStatusChip {
  if (state in CHIP_BY_STATE) {
    return CHIP_BY_STATE[state as PatientEcommerceOpState];
  }
  return CHIP_BY_STATE.unknown;
}

export function countPatientsByOpFilter(
  patients: Patient[],
  filter: PatientOpFilter,
): number {
  return patients.filter((patient) =>
    matchesPatientOpFilter(patient, filter),
  ).length;
}

export {
  countTransactionsByOpFilter,
  matchesTransactionOpFilter,
};

export type { DocumentTransactionRow };
